import $ from 'jquery';
import slick from 'slick-carousel';
import axios from 'axios';

backBtnLoad()

function ajaxImages() {
    var images = document.getElementsByClassName('propertyImage');
    for (var i = 0; i < images.length; i++) {
        var image = images[i];
        var id = image.getAttribute("data-id");
        var fetched = image.getAttribute('data-fetched');
        if (elementInViewport(image) && image.src.includes('giphy.gif') && fetched !== 'true') {
            image.setAttribute('data-fetched', 'true');
            axios.get('/residential/thumbnail/' + id)
                .then(function (response) {
                    // handle success
                    console.log(response.data);
                    var elements = document.querySelectorAll('[data-id="' + response.data.id + '"]');
                    elements[0].src = response.data.picture;

                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                });
        }
    }
}
window.ajaxImages = ajaxImages;
ajaxImages()
window.addEventListener('scroll', function(){
    ajaxImages()
})

function elementInViewport(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while(el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    return (
        top < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset
    );
}
window.elementInViewport = elementInViewport;
$(document).ready(()=>{



    const currentYearEls = document.getElementsByClassName('current-year');
    const date = new Date();
    const currentYear = date.getFullYear();
    for (let i = 0; i < currentYearEls.length; i++) {
        console.log(currentYearEls[i]);
        currentYearEls[i].innerHTML = currentYear.toString();
    }

    $('#propertyImageSlide').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        adaptiveHeight: true,
        asNavFor: '#propertyImageNav',
        lazyLoad: 'progressive',
    });
    $('#propertyImageNav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '#propertyImageSlide',
        dots: false,
        arrows: true,
        centerMode: true,
        focusOnSelect: true,
        lazyLoad: 'progressive',
        prevArrow: $('#prevButton'),
        nextArrow: $('#nextButton')
    });
    $('.testimonials__slider').slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,

        responsive: [
            {
                breakpoint: 900,
                settings: {
                    arrows: false,
                    adaptiveHeight: true
                }
            }
        ]
    })
})

function openNav() {
    // nav menu and mobileButton's 3 bars
    var navBar = document.getElementById('menu'),
        bar1 = document.getElementById('bar1'),
        bar2 = document.getElementById('bar2'),
        bar3 = document.getElementById('bar3');
    if (navBar.style.transform !== "translateX(0px)") {
        //opens mobile nav menu and adds X animation to mobileButton
        navBar.style.transform = "translateX(0px)";
        bar1.style.animation = "topX .5s forwards";
        bar2.style.animation = "midX .5s forwards";
        bar3.style.animation = "bottomX .5s forwards";
    } else {
        //closes mobile nav menu and adds hamburger animation to mobileButton
        navBar.style.transform = "translateX(-1000px)";
        bar1.style.animation = "topRX .5s both";
        bar2.style.animation = "midRX .5s both";
        bar3.style.animation = "bottomRX .5s both";
    }
}

window.openNav = openNav;

function backBtnLoad() {
    if(document.referrer.includes('arnett') || document.referrer.includes('idmtesting')) {
        document.getElementById('backBtn').style.display = 'block';
    }
}




// WEBPACK FOOTER //
// ./resources/js/frontend.js